module.exports = __webpack_public_path__ + "static/img/img_mindset.2f7b979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_mindset.png
// module id = mg1+
// module chunks = 0